import { updateArrInStore } from '@/store/storeHelpers';

export default {
  setContacts: (state, contacts) => {
    state.contacts = contacts;
  },
  setContactsLoading: (state, loading) => {
    state.contactsLoading = loading;
  },
  setContactsInfo: (state, contactsInfo) => {
    state.contactsInfo = contactsInfo;
  },
  setContactLoading: (state, loading) => {
    state.contactLoading = loading;
  },
  setActiveContact: (state, contact) => {
    state.activeContact = contact;
  },
  setUnavailableContactId: (state, contactId) => {
    state.unavailableContactId = contactId;
  },
  updateContactInList: (state, contact) => {
    updateArrInStore(state, contact, 'contacts');
  },
  setContactsImportStatus: (state, status) => {
    state.contactsImportStatus = status;
  },
  updateInvitedContacts: (state, contacts) => {
    state.invitedContacts = [
      ...new Set([...(state.invitedContacts || []), ...contacts]),
    ];
  },

  setSuggestionsLoading: (state, value) => {
    state.suggestionsLoading = value;
  },

  setBoardsLoaded: (state, value) => {
    state.boardsLoaded = value;
  },

  setBoards: (state, value) => {
    state.boards = value;
  },

  setBoardsConfig: (state, config) => {
    state.boardsConfig = config;
  },
};
